module.exports = "textarea{\r\n    height:80px;\r\n}\r\n\r\n\r\n.row:nth-child(odd){\r\n    background: #ececec;\r\n    padding-top: 10px;\r\n  }\r\n\r\n\r\n.row:nth-child(even){     \r\n    padding-top: 10px;\r\n  }  "


//////////////////
// WEBPACK FOOTER
// ./src/app/sainik-registration/battlecasualty/battlecasualty.component.css
// module id = ./src/app/sainik-registration/battlecasualty/battlecasualty.component.css
// module chunks = main